import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {FiltroConsultaMicroempresarios} from '../../Model/filtroConsultaMicroempresarios';
import {UserService} from '../../../services/user.service';
import {ConsultaMicroempresariosService} from '../../Service/consultaMicroempresarios.service';
import {Router} from '@angular/router';


declare var $: any;
@Component({
    selector: 'app-consultar-microempresarios',
    templateUrl: './consultar-microempresarios.component.html',
    styleUrls: ['./consultar-microempresarios.component.scss'],
    standalone: false
})
export class ConsultarMicroempresariosComponent implements OnInit {
  consultarMicroForm: UntypedFormGroup;
  filtrosConsulta: FiltroConsultaMicroempresarios;
  idCliente: any;
  totalPaginas = 1;
  paginaActual = 0;
  consulta = false;
  fechaActual: string = new Date().toLocaleDateString('en-CA');
  microempresarios: any[] = [];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private user: UserService,
    private consultaMicroService: ConsultaMicroempresariosService,
    public router: Router,
  ) {
    this.consultarMicroForm = this.formBuilder.group({
      fechaInicial: [null],
      fechaFinal: [null],
      estado: [null],
      pagina: 1
    });
  }

  ngOnInit(): void {
    this.idCliente = this.user.getUser().idCliente;
    if(sessionStorage.getItem('filterConsultaMicro')){
      this.consultarMicroForm.setValue(JSON.parse(sessionStorage.getItem('filterConsultaMicro')));
      sessionStorage.removeItem('filterConsultaMicro');
      this.consultarMicroempresarios();
    }
  }

  consultarMicroempresarios() {
    this.filtrosConsulta = this.crearObjetoFiltrosMicroempresario();
    this.consultaMicroService
      .consultarMicroempresarioFiltro(this.filtrosConsulta)
      .subscribe(
        (response: any) => {
          this.totalPaginas = response.paginasTotales;
          this.microempresarios = response.data;
          this.paginaActual = response.paginaActual;
          if (response.data.length > 0){
            this.consulta = true;
          }else{
            this.consulta = false;
            this.mensaje();
          }
        },
        (err) => {
          console.error(err);
        }
      );
  }

  crearObjetoFiltrosMicroempresario(): FiltroConsultaMicroempresarios {
    const filtros: FiltroConsultaMicroempresarios = {
      fechaFinal: this.obtenerValorCampo('fechaFinal'),
      fechaInicial: this.obtenerValorCampo('fechaInicial'),
      idCliente: Number(this.idCliente),
      numPagina: this.obtenerValorCampo('pagina'),
      excel: null,
      estado: null,
    };
    return filtros;
  }

  obtenerValorCampo(nombreCampo: string) {
    return this.consultarMicroForm.get(nombreCampo)?.value;
  }

  mensaje(){
    $('#mensajeModal').modal('show');
  }

  isValidFieldConsultaMicroForm(field: string) {
    return (
      (this.consultarMicroForm.get(field)?.dirty ||
        this.consultarMicroForm.get(field)?.touched) &&
      this.consultarMicroForm.get(field)?.invalid
    );
  }

  campoContieneValor(nombreCampo: string): boolean {
    if (this.consultarMicroForm.get(nombreCampo).value) {
      return true;
    } else {
      return false;
    }
  }

  validarFechas() {
    let fechaInicial = new Date();
    let fechaFinal = new Date();
    if (this.campoContieneValor('fechaInicial')) {
      fechaInicial = new Date(this.obtenerValorCampo('fechaInicial'));
    }
    if (this.campoContieneValor('fechaFinal')) {
      fechaFinal = new Date(this.obtenerValorCampo('fechaFinal'));
    }
    if (fechaInicial.getTime() > fechaFinal.getTime()) {
      this.consultarMicroForm.controls.fechaInicial.setErrors({
        incorrect: true,
      });
    } else {
      this.consultarMicroForm.controls.fechaInicial.setErrors(null);
      this.consultarMicroForm.controls.fechaFinal.setErrors(null);
    }
  }

  cualquierCampoIngresado(): boolean {
    return (
      this.campoContieneValor('estado') ||
      this.campoContieneValor('fechaInicial') ||
      this.campoContieneValor('fechaFinal')
    );
  }

  limpiarFormulario() {
    this.consultarMicroForm.reset();
    this.consultarMicroForm.controls.pagina.patchValue(1);
    $('.selectpicker').selectpicker('refresh');
    this.consulta = false;
  }

  guardarFiltro(){
    sessionStorage.setItem('filterConsSol', JSON.stringify(this.consultarMicroForm.value));
  }

  // pagination
  resetPage() {
    this.consultarMicroForm.controls.pagina.patchValue(1);
  }

  selectPage(pageNumber: number) {
    this.consultarMicroForm.controls.pagina.patchValue(pageNumber);
    this.consultarMicroempresarios();
  }

  verDetalles(numeroSolicitud: any) {
    sessionStorage.setItem('filterConsultaMicro', JSON.stringify(this.consultarMicroForm.value));
    this.router.navigate([
      '/solicitud/intermediario/' + numeroSolicitud,
    ]);
  }

  generarReporte(isExcel: boolean) {
    this.filtrosConsulta.excel = isExcel;
    this.consultaMicroService
      .generarReporteMicroempresario(this.filtrosConsulta)
      .subscribe(
        (response: any) => {
          if (response.exitoso === true) {
            const a = document.getElementById('downloadFile');
            a.setAttribute(
              'href',
              `data:${response.mimeType};base64,${response.data}`
            );
            a.setAttribute('download', unescape(response.fileName));
            a.click();
          }
        },
        (err) => {
          console.error(err);
        }
      );
  }
}
